module.exports = {"id":"206626","name":"Mikael Ishak","rating":"72","photo":"./data/images/photos/1/206626.png","club":{"name":"1. FC Nuremberg","logo":"./data/images/clubs/1.FCNuremberg.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MikaelIshak0.json
// module id = 3018
// module chunks = 0